import { useState } from "react";
import Button from "shared/UI/Buttons/Button";
import { TrackerType } from "core/state/Trackers/TrackerType";
import { useTranslation } from "react-i18next";
import { StatusModal } from "shared/UI/StatusModal/StatusModal";

export const SyncTrackerDataButton = ({ trackerType }: { trackerType: TrackerType }) => {
  const { t } = useTranslation(undefined, { keyPrefix: "wellbeing.trackers.syncData" });
  const trackerTypeName = TrackerType[trackerType].toLowerCase();
  const [showPermissionModal, setShowPermissionModal] = useState(false);

  return (
    <>
      <Button text={t("buttonLabel")} onClick={() => setShowPermissionModal(true)} />
      {showPermissionModal && (
        <StatusModal
          data={{
            title: t("modal.title", { trackerTypeName }),
            description: t("modal.description", { trackerTypeName }),
            cta: t("modal.cta"),
          }}
          status="info"
          handleConfirm={() => setShowPermissionModal(false)}
        />
      )}
    </>
  );
};
